import { render, staticRenderFns } from "./SolicitacoesComentarios.vue?vue&type=template&id=8a581a5c&scoped=true"
import script from "./SolicitacoesComentarios.vue?vue&type=script&lang=js"
export * from "./SolicitacoesComentarios.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesComentarios.vue?vue&type=style&index=0&id=8a581a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a581a5c",
  null
  
)

export default component.exports